var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-controller w-full justify-end"},_vm._l((_vm.$store.state.chat.activeChatParties),function(chatParty){return _c('chat-party-modal',{key:chatParty.id,staticClass:"mx-2",attrs:{"chat-party":chatParty}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }